import { NavLink } from "react-router-dom";
import { Dumbbell, ClipboardList, TrendingUp, History, ShieldCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const tabs = [
  { to: "/", label: "Entraînement", icon: Dumbbell, testid: "nav-entrainement" },
  { to: "/programme", label: "Programme", icon: ClipboardList, testid: "nav-programme" },
  { to: "/progression", label: "Progression", icon: TrendingUp, testid: "nav-progression" },
  { to: "/historique", label: "Historique", icon: History, testid: "nav-historique" },
];

export const BottomNav = () => {
  const { user } = useAuth();
  const allTabs = user?.role === "admin"
    ? [...tabs, { to: "/admin", label: "Admin", icon: ShieldCheck, testid: "nav-admin" }]
    : tabs;
  return (
  <nav className="fixed bottom-0 left-0 right-0 z-40 border-t-2 border-[#00E5FF] bg-[#0A0A10]">
    <div className="max-w-md mx-auto flex">
      {allTabs.map(({ to, label, icon: Icon, testid }) => (
        <NavLink key={to} to={to} end={to === "/"} data-testid={testid}
          className={({ isActive }) =>
            `flex-1 flex flex-col items-center gap-1 py-2.5 pb-4 text-[10px] uppercase tracking-wider transition-colors ${
              isActive ? "text-[#00E5FF]" : "text-[#8A8A95] hover:text-white"}`}>
          <Icon size={22} strokeWidth={2} />
          {label}
        </NavLink>
      ))}
    </div>
  </nav>
  );
};
